export default __webpack_public_path__ + "static/media/sideNavLogo.0eedb68c.png";